import React, { Component } from "react";
import { graphql, compose } from "react-apollo";
import { observer } from "mobx-react";
import { CaseManagementStore, IsSupervisor, IsAgentAllowedToAssignToOther, isAllowDisableUnassignCase } from "Store";
import {
  mutationAssignCaseToAgent,
  mutationCloseCase,
  mutationAddNoteToCaseClosed,
  mutationUnassignAgentFromCase,
  mutationCloseCaseWithNote
} from "Apollo";
import { ShowNotice } from "Store";
import HeaderView from "./HeaderView";
import { mutationAssignCaseToOther } from "../../../Apollo";

export default compose(
  graphql(mutationAssignCaseToOther, {
    name: "assignCaseToOtherMutate"
  }),
  graphql(mutationCloseCase, {
    name: "closeCaseMutate"
  }),
  graphql(mutationAddNoteToCaseClosed, {
    name: "addNoteToClosedMutate"
  }),
  graphql(mutationUnassignAgentFromCase, {
    name: "unassignAgentFromCaseMutate"
  }),
  graphql(mutationCloseCaseWithNote, {
    name: "closeCaseWithNoteMutate"
  }),
)(
  observer(
    class Header extends Component {
      render() {
        const {
          selectedCase,
          selectedTab,
          showInfoPanel
        } = CaseManagementStore;
        if (selectedCase) {
          const isMyTab = selectedTab === "my";
          const customer = selectedCase.customerChannelHandler;
          const name = customer.name;
          const image = customer.displayPicture;
          const channel = selectedCase.channel.name;
          const channelName = selectedCase.channelHandler.name;

          return (
            <HeaderView
              name={name}
              image={image}
              channel={channel}
              channelName={channelName}
              showAssignToOtherButton={IsAgentAllowedToAssignToOther()}
              showCloseButton={isMyTab}
              showUnassignButton={isMyTab && !isAllowDisableUnassignCase()}
              showInfo={showInfoPanel}
              onOpenInfoPanel={this.onOpenInfoPanel}
              onCloseCase={this.onCloseCase}
              onUnassign={this.onUnassign}
              onAssignToOther={this.onAssignToOther}
            />
          );
        } else {
          return null;
        }
      }

      onOpenInfoPanel = () => {
        CaseManagementStore.showInfoPanel = true;
      };

      onCloseCase = async (note, isCsatSent) => {
        const {
          selectedCase: { id: caseId, isEscalated }
        } = CaseManagementStore;

        // bail out if note has been written
        if (note.length === 0) return;

        // cancel if there exist pending message
        if (isEscalated) {
          ShowNotice("case-close-error");
          return;
        }

        try {
          const { data: { closeCaseWithNote: updatedCase } } = await this.props.closeCaseWithNoteMutate({
            variables: {
              case: {
                id: caseId
              },
              isCsatSent: isCsatSent,
              content: note
            }
          })
          CaseManagementStore.subsCases.set(updatedCase.id.toString(), updatedCase)
          ShowNotice("case-close-success");
        } catch (error) {
          ShowNotice("case-close-error");
        }
      };

      onUnassign = async () => {
        const caseId = CaseManagementStore.selectedCase.id;
        try {
          await this.props.unassignAgentFromCaseMutate({
            variables: {
              case: {
                id: caseId
              }
            }
          });
          ShowNotice("case-unassign-success");
        } catch (error) {
          ShowNotice("case-unassign-error");
        }
      };

      onAssignToOther = async agentId => {
        const caseId = CaseManagementStore.selectedCase.id;
        try {
          await this.props.assignCaseToOtherMutate({
            variables: {
              case: {
                id: caseId
              },
              agent: {
                id: agentId
              }
            }
          });
          ShowNotice("case-assign-other-success");
        } catch (error) {
          ShowNotice("case-assign-other-error");
        }
      };
    }
  )
);



// WEBPACK FOOTER //
// ./src/module-case-management/content-panel/header/HeaderWithStoreMutation.js